import { render, staticRenderFns } from "./newOrder.vue?vue&type=template&id=590fc789&scoped=true&"
import script from "./newOrder.vue?vue&type=script&lang=js&"
export * from "./newOrder.vue?vue&type=script&lang=js&"
import style0 from "./newOrder.vue?vue&type=style&index=0&id=590fc789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590fc789",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590fc789')) {
      api.createRecord('590fc789', component.options)
    } else {
      api.reload('590fc789', component.options)
    }
    module.hot.accept("./newOrder.vue?vue&type=template&id=590fc789&scoped=true&", function () {
      api.rerender('590fc789', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale-nc/detail/components/newOrder.vue"
export default component.exports